import type { OilPhaseVolumeFactorBoCalculator } from "../../d";
import { solutionGasRsoCalculator } from "./solutionGasRsoCalculator";

export const oilPhaseVolumeFactorBoCalculator: OilPhaseVolumeFactorBoCalculator =
  params => {
    const {
      oilAPI,
      temperatureInRankine,
      inSituPressurePSIA,
      bubblePointPressurePSIA,
      solutionGasRsoInSitu,
      gasOilRatio
    } = params;

    const { rsc1, rsc2, rsc3, normalizedGasSGYgn } =
      solutionGasRsoCalculator(params);

    // LOOKUP VALUES H48::H50
    const boc1LessThan30 = 4.677 * 10 ** -4;
    const boc2LessThan30 = 1.751 * 10 ** -5;
    const boc3LessThan30 = -0.00000001811;

    // LOOKUP VALUES I48::I50
    const boc1MoreThan30 = 0.0004677;
    const boc2MoreThan30 = 1.1 * 10 ** -5;
    const boc3MoreThan30 = 0.000000001337;

    // D48::D50 - SELECT FROM ABOVE VALUES BASED ON oilAPI
    const boc1 = oilAPI > 30 ? boc1MoreThan30 : boc1LessThan30;
    const boc2 = oilAPI > 30 ? boc2MoreThan30 : boc2LessThan30;
    const boc3 = oilAPI > 30 ? boc3MoreThan30 : boc3LessThan30;

    // D43: =D33*D30*(J18^D34)*EXP(D35*(D7/D15))
    let solutionGasPbRsb =
      rsc1 *
      normalizedGasSGYgn *
      bubblePointPressurePSIA ** rsc2 *
      Math.exp(rsc3 * (oilAPI / temperatureInRankine));
    solutionGasPbRsb =
      solutionGasPbRsb > gasOilRatio ? gasOilRatio : solutionGasPbRsb;

    // D45: =(-1433+5*D43+17.2*D15-1180*D30+12.61*D7)/((10^5)*D3)
    const oilCompressUnsat =
      (-1433 +
        5 * solutionGasPbRsb +
        17.2 * temperatureInRankine -
        1180 * normalizedGasSGYgn +
        12.61 * oilAPI) /
      (10 ** 5 * inSituPressurePSIA);
    // D54: =1+D48*D43+D49*(D15-520)*(D7/D30)+D50*D43*(D15-520)*(D7/D30)
    const oilFormFactorPb =
      1 +
      boc1 * solutionGasPbRsb +
      boc2 * (temperatureInRankine - 520) * (oilAPI / normalizedGasSGYgn) +
      boc3 *
        solutionGasPbRsb *
        (temperatureInRankine - 520) *
        (oilAPI / normalizedGasSGYgn);
    // D56: =D54*EXP(D45*(J18-D3))
    const oilFormationVolumeFactorUnSatBo =
      oilFormFactorPb *
      Math.exp(
        oilCompressUnsat * (bubblePointPressurePSIA - inSituPressurePSIA)
      );

    // D52: =1+D48*J12+D49*(D15-520)*(D7/D30)+D50*J12*(D15-520)*(D7/D30)
    const oilFormationVolumeFactorSatBo =
      1 +
      boc1 * solutionGasRsoInSitu +
      boc2 * (temperatureInRankine - 520) * (oilAPI / normalizedGasSGYgn) +
      boc3 *
        solutionGasRsoInSitu *
        (temperatureInRankine - 520) *
        (oilAPI / normalizedGasSGYgn);

    return {
      solutionGasPbRsb,
      oilCompressUnsat,
      oilFormationVolumeFactorSatBo,
      oilFormationVolumeFactorUnSatBo
    };
  };
